import { Select, Spin } from "antd";
import { Option } from "antd/es/mentions";
import axios from "axios";
import React, { useEffect, useState } from "react";
import PaymentList from "./PaymentList";
import { BlinkBlur, OrbitProgress } from "react-loading-indicators";
import VoucherModal from "./VoucherModal";
import { api } from "../../../../config/api";

const PaymentScreen = ({ isVisible,
  onClose,
  precoTotal,
  setPagamentoConcluido,
  setPagItem,
  pagamentos,
  setPagamentos,
  idLoja,
  formasDePagamento,
  totalPago,
  setTotalPago
}) => {

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const operador = window.localStorage.getItem("operador");
  const [restauranteId, setRestauranteId] = useState('');

  const [loading, seetLoading] = useState(false);
  const [visualizarModalVoucher, setVisualizarModalVoucher] = useState(false);
  const [pagamentosTela, setPagamentosTela] = useState(pagamentos);
  const [totalPagoTela, setTotalPagoTela] = useState(totalPago);

  const [voucher, setVoucher] = useState('');
  const [informacoesVoucher, setInformacoesVoucher] = useState('');
  const [valor, setValor] = useState('');


  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      axios
        .get(
          `${api.techfood}/v1/restaurantes/usuario/${idUser}`,
          options,
        )
        .then(restaurante => {
          setRestauranteId(restaurante.data.id);
        });
      setPagamentosTela(pagamentos);
    }
  }, [idUser, accessToken]);


  const [formaDePagamentoSelecionada, setFormaDePagamentoSelecionada] =
    useState('01');

  useEffect(() => {
    console.log('precoTotal');
    console.log('precoTotal');
    console.log('precoTotal');
    console.log('precoTotal');
    console.log(precoTotal);
    console.log((parseFloat(precoTotal) - parseFloat(totalPagoTela)).toFixed(2));
    console.log(totalPagoTela);
    console.log(valor);

    // Formatar o valor com a máscara (por exemplo, R$ 1.000,00)
    let valorFormatado = parseFloat(parseFloat(precoTotal) - parseFloat(totalPagoTela)); // Converter para valor decimal
    valorFormatado = valorFormatado.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    setValor(valorFormatado);
    console.log(formaDePagamentoSelecionada);
  }, [precoTotal]);
  function formatISODate(isoString) {
    const date = new Date(isoString);

    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Mês é zero-indexado
    const year = date.getUTCFullYear();

    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const tratarValor = text => {
    console.log('valor');
    console.log(text);
    let valorFormatado = text.replace(/\D/g, '');
    // Verificar se o valor é vazio ou contém apenas zeros
    if (valorFormatado === '' || parseInt(valorFormatado) === 0) {
      setValor('R$ 0'); // Define o valor como vazio
      valorFormatado = 'R$ 0';
    } else {
      // Formatar o valor com a máscara (por exemplo, R$ 1.000,00)
      valorFormatado = parseFloat(valorFormatado) / 100; // Converter para valor decimal
      valorFormatado = valorFormatado.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    }
    setValor(valorFormatado);
  };

  const [paymentType, setPaymentType] = useState("Cartão de Débito");
  const [amount, setAmount] = useState("");
  const [payments, setPayments] = useState([]);

  const handleAddPayment = () => {
    if (amount && parseFloat(amount) > 0) {
      setPayments((prevPayments) => [
        ...prevPayments,
        { type: paymentType, amount: parseFloat(amount) },
      ]);
      setAmount(""); // Limpa o campo de valor
    }
  };

  const adicionarPagamento = () => {
    console.log(formaDePagamentoSelecionada);
    if (formaDePagamentoSelecionada === '05') {
      console.log('Abrir modal');
      setVisualizarModalVoucher(true);
      return;
    }

    const totalPagoAux = parseFloat(totalPagoTela);
    const valorDigitadoAux = parseFloat(
      valor.replace('R$', '').replace('.', '').replace(',', '.').trim()
    );


    if (valorDigitadoAux == 0) {
      return;
    }
    console.log('adicionarPagamento');
    console.log('Forma de pagamento selecionada:', formaDePagamentoSelecionada);
    console.log('Valor digitado:', valor);
    console.log('Preço total:', precoTotal);
    console.log('Total pago auxiliar:', totalPagoAux);
    console.log('Valor digitado auxiliar:', valorDigitadoAux);

    if (totalPagoAux + valorDigitadoAux <= parseFloat(precoTotal) || formaDePagamentoSelecionada == '01') {
      console.log('formaDePagamentoSelecionada');

      console.log(formaDePagamentoSelecionada);
      if (valor && formaDePagamentoSelecionada) {
        const formaDePagamentoFiltrada = formasDePagamento.find(
          (formaPag) => formaPag.value === formaDePagamentoSelecionada
        );
        console.log(formasDePagamento);
        console.log('Forma de pagamento filtrada:', formaDePagamentoFiltrada);
        console.log('Forma de pagamento é válida:', formaDePagamentoFiltrada !== undefined);

        if (formaDePagamentoFiltrada !== undefined) {
          setTotalPagoTela(
            totalPagoAux + valorDigitadoAux
          );

          const novosPagamentos = [
            ...pagamentosTela,
            {
              tipo: formaDePagamentoSelecionada,
              tipoNome: formaDePagamentoFiltrada.label,
              valor: valor,
            },
          ];
          setPagamentosTela(novosPagamentos);

          console.log('Preço restante:', precoTotal - totalPagoAux - valorDigitadoAux);
          if (precoTotal - (totalPagoAux + valorDigitadoAux) >= 0) {
            setValor(
              (precoTotal - (totalPagoAux + valorDigitadoAux)).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
            );
          } else {
            setValor(
              (0).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              }));
          }


        }
      } else {
        console.log('Faltam o valor ou a forma de pagamento');
      }
    } else {
      console.log('Pagamento superior ao valor da compra');
    }
  };



  /* const confirmarPagamento = () => {
     setPagamentoConcluido(true);
     let pagItemAux = new Array();
     pagamentos.map(pagamento => {
       let valorFormatado = typeof pagamento.valor === 'string' ? parseFloat(pagamento.valor.replace(/\D/g, '')) / 100 : pagamento.valor;
 
       let pagamentoFormatado = {
         tPag: pagamento.tipo,
         vPag: valorFormatado.toFixed(2),
         xPag: pagamento.tipoNome,
       };
       console.log(pagamento.tipo);
       if (pagamento.tipo === "05" || pagamento.tipo === 5) {
         console.log('if de pagamento');
         pagamentoFormatado.idReferencialVoucher = informacoesVoucher.id;
       }
 
       pagItemAux.push(pagamentoFormatado);
     });
     setPagItem(pagItemAux);
 
     onClose();
   };*/

  const confirmarPagamento = () => {
    setPagamentoConcluido(true);
    setPagamentos(pagamentosTela);
    setTotalPago(totalPagoTela);
    setTotalPagoTela(0);
    const pagItemAux = pagamentosTela.map((pagamento) => {
      // Converte valor (string -> float)
      const valorFormatado =
        typeof pagamento.valor === "string"
          ? parseFloat(pagamento.valor.replace(/\D/g, "")) / 100
          : pagamento.valor;

      // Base do objeto
      let pagamentoFormatado = {
        tPag: pagamento.tipo,
        vPag: valorFormatado.toFixed(2),
        xPag: pagamento.tipoNome,
      };

      // Se for voucher (05)
      if (pagamento.tipo === "05" || pagamento.tipo === 5) {
        pagamentoFormatado.idReferencialVoucher = informacoesVoucher.id;
      }

      // Se for cartão (3 ou 4)
      if (pagamento.tipo === "03" || pagamento.tipo === 3 || pagamento.tipo === "04" || pagamento.tipo === 4) {
        pagamentoFormatado.card = {
          tpIntegracao: "2",
        };
      }

      return pagamentoFormatado;
    });

    setPagItem(pagItemAux);
    onClose();
  };














  /*const handleRemovePayment = (index) => {
    setPayments((prevPayments) =>
      prevPayments.filter((_, i) => i !== index)
    );
  };*/

  const total = 1.5;
  const paid = payments.reduce((sum, payment) => sum + payment.amount, 0);


  const estiloPaginaPagamento = {
    width: '100%',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    boxSizing: 'border-box',
  };

  const estiloContainerPagamento = {
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
    padding: '20px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.10)',
    boxSizing: 'border-box',
  };

  const estiloLoading = {
    minHeight: '260px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const estiloCabecalhoPagamento = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    paddingBottom: '14px',
    marginBottom: '16px',
    borderBottom: '1px solid #e5e7eb',
  };

  const estiloTituloPagamento = {
    margin: 0,
    color: '#111827',
    fontSize: '22px',
    fontWeight: '800',
  };

  const estiloDescricaoPagamento = {
    display: 'block',
    marginTop: '4px',
    color: '#6b7280',
    fontSize: '13px',
  };

  const estiloIconePagamento = {
    width: '46px',
    height: '46px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: '13px',
    background: '#f3f4f6',
    fontSize: '24px',
  };

  const estiloCardFormulario = {
    padding: '16px',
    background: '#f8fafc',
    border: '1px solid #e5e7eb',
    borderRadius: '13px',
  };

  const estiloGridFormulario = {
    display: 'grid',
    gridTemplateColumns:
      'minmax(220px, 1.3fr) minmax(160px, 0.7fr) auto',
    gap: '12px',
    alignItems: 'end',
  };

  const estiloCampo = {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    minWidth: 0,
  };

  const estiloLabel = {
    color: '#374151',
    fontSize: '12px',
    fontWeight: '700',
  };

  const estiloInputValor = {
    width: '100%',
    height: '40px',
    padding: '0 12px',
    background: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '9px',
    color: '#111827',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const estiloBotaoAdicionar = {
    minHeight: '40px',
    padding: '9px 18px',
    border: '1px solid #111827',
    borderRadius: '9px',
    background: 'linear-gradient(135deg, #374151, #111827)',
    color: '#ffffff',
    fontSize: '13px',
    fontWeight: '800',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    boxShadow: '0 5px 12px rgba(17, 24, 39, 0.20)',
  };

  const estiloResumoPagamento = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '12px',
    marginTop: '14px',
  };

  const estiloCardResumo = {
    padding: '15px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
  };

  const estiloLabelResumo = {
    display: 'block',
    marginBottom: '5px',
    color: '#6b7280',
    fontSize: '12px',
    fontWeight: '700',
  };

  const estiloValorResumo = {
    color: '#111827',
    fontSize: '20px',
    fontWeight: '800',
  };

  const estiloListaPagamento = {
    marginTop: '14px',
    padding: '14px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    overflowX: 'auto',
  };

  const estiloRodapePagamento = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    paddingTop: '15px',
    marginTop: '15px',
    borderTop: '1px solid #e5e7eb',
  };

  const estiloBotaoFechar = {
    minWidth: '110px',
    minHeight: '42px',
    padding: '9px 18px',
    border: '1px solid #dc2626',
    borderRadius: '9px',
    background: 'linear-gradient(135deg, #ef4444, #b91c1c)',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: '800',
    cursor: 'pointer',
    boxShadow: '0 5px 12px rgba(220, 38, 38, 0.20)',
  };

  const pagamentoIncompleto =
    parseFloat(precoTotal) > totalPagoTela;

  const estiloBotaoConfirmar = {
    minWidth: '130px',
    minHeight: '42px',
    padding: '9px 18px',
    border: pagamentoIncompleto
      ? '1px solid #d1d5db'
      : '1px solid #15803d',
    borderRadius: '9px',
    background: pagamentoIncompleto
      ? '#e5e7eb'
      : 'linear-gradient(135deg, #22c55e, #15803d)',
    color: pagamentoIncompleto
      ? '#9ca3af'
      : '#ffffff',
    fontSize: '14px',
    fontWeight: '800',
    cursor: pagamentoIncompleto
      ? 'not-allowed'
      : 'pointer',
    boxShadow: pagamentoIncompleto
      ? 'none'
      : '0 5px 12px rgba(34, 197, 94, 0.20)',
  };

  return (
    <div style={estiloPaginaPagamento}>
      <div style={estiloContainerPagamento}>
        {loading ? (
          <div style={estiloLoading}>
            <Spin
              spinning={loading}
              tip={
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: '500',
                    color: '#374151',
                  }}
                >
                  Carregando...
                </span>
              }
              size="large"
            />
          </div>
        ) : (
          <>
            <div style={estiloCabecalhoPagamento}>
              <div>
                <h1 style={estiloTituloPagamento}>
                  Formas de Pagamento
                </h1>

                <span style={estiloDescricaoPagamento}>
                  Adicione as formas e os valores recebidos.
                </span>
              </div>

              <div style={estiloIconePagamento}>
                💳
              </div>
            </div>

            <div style={estiloCardFormulario}>
              <div style={estiloGridFormulario}>
                <div style={estiloCampo}>
                  <label style={estiloLabel}>
                    Forma de pagamento
                  </label>

                  <Select
                    style={{ width: '100%' }}
                    placeholder="Selecione a forma de pagamento"
                    value={formaDePagamentoSelecionada}
                    onChange={(value) =>
                      setFormaDePagamentoSelecionada(value)
                    }
                    dropdownMatchSelectWidth={false}
                  >
                    {formasDePagamento.map((forma) => (
                      <Option
                        key={forma.value}
                        value={forma.value}
                      >
                        {forma.label}
                      </Option>
                    ))}
                  </Select>
                </div>

                <div style={estiloCampo}>
                  <label style={estiloLabel}>
                    Valor recebido
                  </label>

                  <input
                    type="text"
                    value={valor}
                    onChange={(e) =>
                      tratarValor(e.target.value)
                    }
                    style={estiloInputValor}
                  />
                </div>

                <button
                  type="button"
                  onClick={adicionarPagamento}
                  style={estiloBotaoAdicionar}
                >
                  ＋ Adicionar pagamento
                </button>
              </div>
            </div>

            <div style={estiloResumoPagamento}>
              <div style={estiloCardResumo}>
                <span style={estiloLabelResumo}>
                  Total da venda
                </span>

                <div style={estiloValorResumo}>
                  {Number(precoTotal || 0).toLocaleString(
                    'pt-BR',
                    {
                      style: 'currency',
                      currency: 'BRL',
                    }
                  )}
                </div>
              </div>

              <div style={estiloCardResumo}>
                <span style={estiloLabelResumo}>
                  Total pago
                </span>

                <div style={estiloValorResumo}>
                  {totalPagoTela.toLocaleString(
                    'pt-BR',
                    {
                      style: 'currency',
                      currency: 'BRL',
                    }
                  )}
                </div>
              </div>
            </div>

            <div style={estiloListaPagamento}>
              <PaymentList
                pagamentos={pagamentosTela}
                setPagamentos={setPagamentosTela}
                precoTotal={precoTotal}
                totalPago={totalPagoTela}
                setTotalPago={setTotalPagoTela}
                setValor={setValor}
                setPagamentoConcluido={
                  setPagamentoConcluido
                }
              />
            </div>

            <div style={estiloRodapePagamento}>
              <button
                type="button"
                onClick={() => {
                  setPagamentosTela([]);
                  setTotalPagoTela(0);
                  onClose();
                }}
                style={estiloBotaoFechar}
              >
                Fechar
              </button>

              <button
                type="button"
                disabled={pagamentoIncompleto}
                style={estiloBotaoConfirmar}
                onClick={confirmarPagamento}
              >
                ✓ Confirmar
              </button>
            </div>
          </>
        )}
      </div>

      <VoucherModal
        visible={visualizarModalVoucher}
        setVisible={setVisualizarModalVoucher}
        accessToken={accessToken}
        idLoja={idLoja}
        precoTotal={precoTotal}
        totalPago={totalPagoTela}
        setTotalPago={setTotalPagoTela}
        valor={valor}
        setValor={setValor}
        pagamentos={pagamentosTela}
        setPagamentos={setPagamentosTela}
        formaDePagamentoSelecionada={
          formaDePagamentoSelecionada
        }
        formasDePagamento={formasDePagamento}
        informacoesVoucher={informacoesVoucher}
        setInformacoesVoucher={
          setInformacoesVoucher
        }
      />
    </div>
  );
};


const styles = {
  buttonRed: {
    backgroundColor: "#ff5c5c",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    width: "110px"
  },

  buttonDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed",
  }

}

export default PaymentScreen;
